import {Injectable} from '@angular/core';
import {ApiConfiguration as faxeConfig} from '@app/rest-client/faxe/api-configuration';
import {AppConfigService} from '@app/services/config/app-config.service';
import { ApiConfiguration as faxeSim} from '@app/rest-client/faxe-sim/api-configuration';


@Injectable({
  providedIn: 'root',
})
export class ApiConfigurationsService {
  constructor(
    private faxeService: faxeConfig,
    private faxeSim: faxeSim
  ) {
  }

  init(): void {
    console.log('Running: ' + AppConfigService.environmentConfigData.name);
    this.faxeService.rootUrl = AppConfigService.environmentConfigData.faxeServiceRootUrl;
    this.faxeSim.rootUrl = AppConfigService.environmentConfigData.faxeSimRootUrl;
  }
}
